import BottomFooter from './BottomFooter';
import Head from './TopHead';
import ClassLink from './home/ClassLink';

function Home() {
    return (
<main>
        <Head />

        <h1 className="home-page-title">Training Options</h1>

        <section className="traning-list">
            <ClassLink title="Microsoft Excel" image="excel-logo.svg" to="/excel" />
            <ClassLink title="Microsoft PowerPoint" image="power-point-logo.svg" to="/power-point" />
            <ClassLink title="Microsoft Power BI" image="power-bi-logo.svg" to="/power-bi" />
            <ClassLink title="SQL Queries" image="sql-logo.png" to="/sql" />
            <ClassLink title="Google Sheets" image="google-sheets-logo.svg" to="/sheets" />
            <ClassLink title="Looker Studio" image="looker-studio-logo.svg" to="/looker-studio" />
            <ClassLink title="Chat GPT - AI for Data Analysis" image="chatgpt-logo.svg" to="/chatgpt" />
            <ClassLink title="Gemini - AI for Data Analysis" image="gemini-logo.svg" to="/gemini" />
            {/* <ClassLink title="Microsoft Teams" image="teams-logo.svg" to="/teams" /> */}
            {/* <ClassLink title="Microsoft SharePoint" image="sharepoint-logo.svg" to="/sharepoint" /> */}
        </section>

        <BottomFooter />
    </main>
    )
    }

    export default Home;